export const ROOT = "*";
export const LOGIN = "/login";
export const DASHBOARD = "/dashboard";
